import styled, { css } from 'styled-components';
import { RichTextEditor } from 'components/atoms/rich-text-editor';

export const Content = styled(RichTextEditor).attrs({
  noToolbar: true,
  readonly: true,
})`
  --rte-min-height: var(--line-height-caption-01);
  --rte-readonly-content-padding: 0 30% 0 0;
  --rte-background: transparent;

  margin-left: -1px;

  ${({ data }) =>
    data.length === 0 &&
    css`
      display: none;
    `};
`;
